import { Alert } from '@mui/material';
import Grid from '@mui/material/Grid';
import useNotify from './Hook';
import { motion, AnimatePresence } from 'framer-motion';

const Notify = () => {
    const { notifications, removeNotify } = useNotify();
    if (notifications) {
        return (
            <Grid
                container
                direction="column"
                justifyContent="flex-end"
                alignItems="flex-end"
                spacing={2}
                rowSpacing={2}
                sx={{
                    position: 'fixed',
                    top: '50px',
                    right: 0,
                    zIndex: 10,
                    overflow: 'hidden',
                    padding: '15px'
                }}
            >
                <Grid item>
                    <AnimatePresence mode={'popLayout'}>
                        {notifications.map((notify, idx) => {
                            return (
                                <motion.div
                                    key={idx}
                                    initial={{ x: 300, opacity: 0 }}
                                    animate={{ x: 0, opacity: 1 }}
                                    exit={{ x: 300, opacity: 0 }}
                                    layout
                                    transition={{
                                        type: 'spring',
                                        duration: 0.9,
                                        delay: 0.1,
                                        bounce: 0.0
                                    }}
                                    order={idx}
                                >
                                    <Alert
                                        key={idx}
                                        severity={notify.type}
                                        sx={{ marginBottom: '5px' }}
                                        onClose={() => {
                                            removeNotify(notify.id);
                                        }}
                                    >
                                        {notify.text}
                                    </Alert>
                                </motion.div>
                            );
                        })}
                    </AnimatePresence>
                </Grid>
            </Grid>
        );
    } else {
        return <></>;
    }
};

export default Notify;
